import React, { useState } from 'react'
import { timeAgo } from '../../../utils'
import { UserAvatarPlaceholder } from '../../icons/UserAvatarPlaceholder'
import { EditDelete } from '@/components/utils/editDelete'
import { DeleteMemberDialog } from './deleteMemberDialog'

export function Member({ member, handleDeleteMember }) {
  const [openMenu, setOpenMenu] = useState(false)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)

  return (
    <div className="flex items-center ml-[35px] mr-[60px] py-[20px] border-b border-grey-200 dark:border-gray-700">
      {showDeleteDialog && (
        <DeleteMemberDialog
          handleDeleteMember={handleDeleteMember}
          memberId={member.id}
          memberName={member.name || member.email}
          handleClose={() => setShowDeleteDialog(false)}
        />
      )}
      <div className="flex items-center w-4/12">
        {!member.last_seen ? (
          <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18.7988" r="17.75" fill="#F9F9F9" stroke="#E4E4E4" strokeWidth="0.5" />
            <g clipPath="url(#clip0_3134_9003)">
              <path
                d="M14 13.7988C14 14.8597 14.4214 15.8771 15.1716 16.6273C15.9217 17.3774 16.9391 17.7988 18 17.7988C19.0609 17.7988 20.0783 17.3774 20.8284 16.6273C21.5786 15.8771 22 14.8597 22 13.7988C22 12.738 21.5786 11.7205 20.8284 10.9704C20.0783 10.2203 19.0609 9.79883 18 9.79883C16.9391 9.79883 15.9217 10.2203 15.1716 10.9704C14.4214 11.7205 14 12.738 14 13.7988Z"
                stroke="#FF4A8E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 27.7988V25.7988C12 24.738 12.4214 23.7205 13.1716 22.9704C13.9217 22.2203 14.9391 21.7988 16 21.7988H19.5"
                stroke="#FF4A8E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25 28.7988V28.8088"
                stroke="#FF4A8E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25 25.7986C25.4483 25.7972 25.8832 25.6454 26.235 25.3675C26.5868 25.0897 26.8352 24.7019 26.9406 24.2661C27.0459 23.8304 27.0019 23.3719 26.8158 22.964C26.6297 22.5562 26.3122 22.2226 25.914 22.0166C25.5162 21.8128 25.0611 21.7496 24.6228 21.8373C24.1845 21.925 23.7888 22.1584 23.5 22.4996"
                stroke="#FF4A8E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_3134_9003">
                <rect width="24" height="24" fill="white" transform="translate(6 6.79883)" />
              </clipPath>
            </defs>
          </svg>
        ) : member.picture ? (
          <img className="rounded-full" width={36} height={37} src={member.picture} alt="user avatar" />
        ) : (
          <UserAvatarPlaceholder />
        )}
        <div className="ml-[15px]">
          <p className="text-[#40424A] dark:text-gray-100 text-base font-bold font-['Manrope'] leading-tight">
            {member.name || member.email}
          </p>
          {!member.joined_at || member.joined_at === -1 ? (
            <p className="w-[265px] text-[#FF4A8E] text-[13px] font-medium font-['Manrope'] leading-none">
              Pending
            </p>
          ) : (
            <p className="w-[265px] text-slate dark:text-gray-400 text-[13px] font-medium font-['Manrope'] leading-none">
              Joined {timeAgo(member.joined_at)}
            </p>
          )}
        </div>
      </div>
      <div className=" w-3/12">
        <p className="text-[#101E9B] dark:text-blue-400 text-[13px] font-medium font-['Manrope'] leading-none">{member.email}</p>
      </div>
      <div className=" w-2/12">
        <p className="text-slate dark:text-gray-300 text-[13px] font-bold font-['Manrope'] leading-none capitalize">
          {member.role || 'admin'}
        </p>
      </div>
      <div className="w-2/12">
        <p className="text-slate dark:text-gray-400 text-[13px] font-medium font-['Manrope'] leading-none">
          {!member.last_seen || member.joined_at === -1
            ? `Invited ${timeAgo(member.invited_at)}`
            : `Last seen ${timeAgo(member.last_seen)}`}
        </p>
      </div>
      <div className='w-1/12 flex items-center justify-end'>
        <div className="flex">
          <button onClick={() => setOpenMenu(member.role !== 'owner')} className={`${member.role === 'owner' && 'opacity-70 cursor-default'}`}>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_3095_10873)">
                <path
                  d="M3 12.7988C3 13.9807 3.23279 15.151 3.68508 16.243C4.13738 17.3349 4.80031 18.3271 5.63604 19.1628C6.47177 19.9985 7.46392 20.6615 8.55585 21.1137C9.64778 21.566 10.8181 21.7988 12 21.7988C13.1819 21.7988 14.3522 21.566 15.4442 21.1137C16.5361 20.6615 17.5282 19.9985 18.364 19.1628C19.1997 18.3271 19.8626 17.3349 20.3149 16.243C20.7672 15.151 21 13.9807 21 12.7988C21 11.6169 20.7672 10.4466 20.3149 9.35468C19.8626 8.26275 19.1997 7.27059 18.364 6.43487C17.5282 5.59914 16.5361 4.9362 15.4442 4.48391C14.3522 4.03162 13.1819 3.79883 12 3.79883C10.8181 3.79883 9.64778 4.03162 8.55585 4.48391C7.46392 4.9362 6.47177 5.59914 5.63604 6.43487C4.80031 7.27059 4.13738 8.26275 3.68508 9.35468C3.23279 10.4466 3 11.6169 3 12.7988Z"
                  stroke="#62718D"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 12.7988V12.8088"
                  stroke="#62718D"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 12.7988V12.8088"
                  stroke="#62718D"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 12.7988V12.8088"
                  stroke="#62718D"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_3095_10873">
                  <rect width="24" height="24" fill="white" transform="translate(0 0.798828)" />
                </clipPath>
              </defs>
            </svg>
          </button>
          {openMenu && (
            <EditDelete
              hideEdit={true}
              onClose={() => setOpenMenu(false)}
              handleEdit={() => console.log('edit')}
              handleDelete={() => {
                setShowDeleteDialog(true)
                setOpenMenu(false)
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}
